import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TableQuestionEntry } from '@entscheidungsnavi/api-types';
import { ReactiveFormsModule } from '@angular/forms';
import { FORWARD_CONTROL_CONTAINER } from '../../../form-elements';
import { EvaluationCheckboxesComponent } from '../../evaluation-checkboxes/evaluation-checkboxes.component';

@Component({
  selector: 'dt-questionnaire-question-table',
  templateUrl: './questionnaire-table.component.html',
  styleUrls: ['./questionnaire-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [FORWARD_CONTROL_CONTAINER],
  imports: [ReactiveFormsModule, EvaluationCheckboxesComponent],
})
export class QuestionnaireQuestionTableComponent {
  @Input()
  entry: TableQuestionEntry;

  @Input()
  formIndex: number;
}
